import React, { useEffect, useState } from "react";
import {
  Box,
  SimpleGrid,
  Card,
  CardBody,
  Text,
  Image,
  VStack,
  HStack,
  Heading,
  Button,
} from "@chakra-ui/react";
import axios from "axios";
import Modal_Pay_Tr_dashboard from "./Modal_Pay_Tr_dashboard";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Teacher_Dashboard_Lib_design = () => {
  const [borrowedBooks, setBorrowedBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchMemberIdAndBorrowedBooks = async () => {
      try {
        const schoolId = sessionStorage.getItem("school_id");
        const staffId = sessionStorage.getItem("staff_id");

        // Fetch member_id from membership API
        const membershipResponse = await axios.get(
          `${BASE_URL}/staff/library/t_membership_details.php?school_id=${schoolId}&staff_id=${staffId}`
        );
        console.log("member", membershipResponse);

        if (
          membershipResponse.data.success &&
          membershipResponse.data.data &&
          membershipResponse.data.data.member_id
        ) {
          const memberId = membershipResponse.data.data.member_id;
          console.log("membr", memberId);

          // Fetch borrowed books using member_id
          const booksResponse = await axios.get(
            `${BASE_URL}/admin/library/issues/borrowed_books.php?school_id=${schoolId}&member_id=${memberId}`
          );
          console.log("book norrow", booksResponse);

          if (
            booksResponse.data.success &&
            booksResponse.data.data.length > 0
          ) {
            setBorrowedBooks(booksResponse.data.data);
          } else {
            setError("No book taken from library.");
          }
        } else {
          setError("No membership details found.");
        }
      } catch (err) {
        if (err.response && err.response.status === 404) {
          setError("No data found.");
        } else {
          setError("An error occurred while fetching data.");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchMemberIdAndBorrowedBooks();
  }, []);

  if (loading) {
    return <Box p={6}>Loading...</Box>;
  }

  if (error) {
    return <Box p={6}>{error}</Box>;
  }

  // Function to toggle the modal visibility
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <Box p={6}>
      {borrowedBooks.length === 0 ? (
        <Box p={6}>No book taken from library.</Box>
      ) : (
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
          {borrowedBooks.map((book) => (
            <Card
              key={book.id}
              variant="outline"
              overflow="hidden"
              boxShadow="sm"
              _hover={{
                boxShadow: "lg",
                transform: "scale(1.02)",
              }}
              transition="all 0.2s ease-in-out"
            >
              <CardBody>
                <VStack align="stretch" spacing={3}>
                  <Image
                    src={
                      book.image_url ||
                      "https://m.media-amazon.com/images/I/81q77Q39nEL._AC_UF1000,1000_QL80_.jpg"
                    }
                    alt={book.title}
                    width="80px"
                    height="80px"
                    objectFit="cover"
                    borderRadius="md"
                    alignSelf="center"
                  />
                  <Box>
                    <Heading
                      color="purple.600"
                      size="sm"
                      noOfLines={2}
                      textAlign="center"
                    >
                      {book.title}
                    </Heading>
                  </Box>
                  <Box fontSize="sm" color="gray.600">
                    <HStack justify="space-between">
                      <Text fontSize="10px">Book Taken:</Text>
                      <Text
                        fontSize="10px"
                        fontWeight="medium"
                        color="blue.600"
                      >
                        {book.issue_date}
                      </Text>
                    </HStack>
                    <HStack justify="space-between">
                      <Text fontSize="10px">Return Date:</Text>
                      <Text
                        fontSize="10px"
                        fontWeight="medium"
                        color="blue.600"
                      >
                        {book.return_date || "Not returned"}
                      </Text>
                    </HStack>
                    <HStack justify="space-between" mt={2}>
                      <Text fontSize="10px">Status:</Text>
                      <Text
                        fontSize="10px"
                        fontWeight="medium"
                        color={
                          book.status === "Returned" ? "green.500" : "red.500"
                        }
                      >
                        {book.status === "Returned"
                          ? "Returned"
                          : "Not Returned"}
                      </Text>
                    </HStack>
                    {book.fine_amount && book.fine_amount !== "0.00" && (
                      <HStack justify="space-between" mt={2}>
                        <Text fontSize="10px">Fine Amount:</Text>
                        <Text
                          fontSize="10px"
                          fontWeight="medium"
                          color="red.500"
                        >
                          ${book.fine_amount}
                        </Text>
                      </HStack>
                    )}
                  </Box>
                  {book.status === "Returned" &&
                    book.fine_amount !== null &&
                    book.paid === 0 && (
                      <Button
                        colorScheme="blue"
                        size="xs"
                        alignSelf="flex-end"
                        mt={4}
                        width="100%"
                        onClick={() => {
                          handleOpenModal();
                          setData(book);
                        }}
                      >
                        Pay
                      </Button>
                    )}
                </VStack>
              </CardBody>
            </Card>
          ))}
        </SimpleGrid>
      )}
      {isModalOpen && data && (
        <Modal_Pay_Tr_dashboard
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          amount={data.fine_amount || "0.00"}


          last={data.due_date || "N/A"}
          memberId={data.member_id}
          fineeId={data.fine_id}
          staffId={data.staff_id}
          totalAmount={data.fine_amount}
          TeacherLedgerId={data.teacher_ledger_id}
        />
      )}
    </Box>
  );
};

export default Teacher_Dashboard_Lib_design;
